<div class="form-label">
    <h1>{{'auth.forgot-password.title' | translate}}</h1>
</div>
<form [formGroup]="forgotPasswordForm">
    <mat-form-field appearance="outline" style="width: 100%" color="primary" *ngIf="!isSubmitted">
        <mat-label>{{'common.email' | translate}}</mat-label>
        <input matInput name="login" [formControl]="userNameFormControl" autocomplete="off">
        <mat-error *ngIf="userNameFormControl.hasError('required')">
            {{'common.field-required' | translate}}
        </mat-error>
    </mat-form-field>

    <div *ngIf="isSubmitted" class="email-sent-success">
        {{'common.email-sent' | translate}}
    </div>

    <div class="form-button-row">
        <div class="form-button-cell">
            <button mat-raised-button color="primary" (click)="sendPassword()" [disabled]="!forgotPasswordForm.valid || isSubmitted">
                {{'common.send' | translate}}
            </button>
        </div>
        <div class="form-button-cell">
            <a (click)="onSignOut()">{{'auth.back-to-sign-in' | translate}}</a>
        </div>
    </div>
</form>